<template>
  <div
    v-show="internalShow"
    style="z-index: 6; position: fixed; height: 100%; width: 100%"
    :class="{ 'bg-black-radial': result.show}"
  >
    <!-- <div
      v-show="showResultMessage"
      class="text-center white--text"
      :class="result.success ? (onsiteMode ? 'bg-blue-radial' : 'bg-teal-radial') : 'bg-orange-radial'"
      style="position: fixed; height: 100%; width: 100%;"
    > -->
    <div
      v-show="showResultMessage"
      class="text-center white--text"
      :class="result.success ? (onsiteMode ? 'bg-blue-dark' : 'bg-blue-dark') : 'bg-orange-radial'"
      style="position: fixed; height: 100%; width: 100%;"
    >
      <v-toolbar v-show="result.message" dark color="transparent" elevation="0" class="px-1">
        <v-btn icon @click="updateResult({ show: false })">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>

      <div class="fixed-center2">
        <p style="word-break: keep-all" class="headline font-weight-bold px-2" v-html="result.title"></p>

        <p style="word-break: keep-all" class="px-2" v-html="result.message"></p>

        <v-icon
          :size="Math.min(windowInfo().min, 500)"
          color="white"
          style="margin: 25px 0"
        >{{result.success ? 'mdi-checkbox-marked-circle-outline' : 'mdi-close-circle-outline' }}</v-icon>
      </div>
    </div>

    <div
      v-show="!showResultMessage"
      id="rippleResultEffect"
      style="position: fixed; border-radius: 50%"
    ></div>
  </div>

  <!-- <v-toolbar dark color="transparent" elevation="0" class="px-1">
        <v-btn icon @click="updateResult({ show: false })">
          <v-icon>mdi-close</v-icon>
        </v-btn>
  </v-toolbar>-->
</template>

<script>
import { mapState, mapMutations } from "vuex";
import animator from "@/helpers/animator";

export default {
  name: "RippleResult",
  data: () => ({
    showResultMessage: false,
    internalShow: false,
    selectedRadialColor: "radial-gradient(circle, #2196f3, #0d47a1)",
  }),
  computed: {
    ...mapState(["result"]),
    radialColor() {
      return this.result.success
        ? this.onsiteMode
          ? "radial-gradient(circle, #2196f3, #0d47a1)"
          // : "radial-gradient(circle, #009688, #004D40)"
          : "radial-gradient(circle, #009688, #0047BB)"
        : "radial-gradient(circle, #FF9800, #E65100)";
      // : "radial-gradient(circle, #f44336, #b71c1c)";
    },
  },
  methods: {
    ...mapMutations(["updateResult"]),
    rippleExpand() {
      this.selectedRadialColor = this.radialColor;
      this.showResultMessage = false;
      let rippleEleId = "rippleResultEffect";

      let completeCallback = () => {
        const statusBarColor = this.result.success
          ? this.onsiteMode
            ? "#0d47a1"
            // : "#004D40" 
            : "#0047BB"
          : "#E65100";

        this.setStatusBackgroundBarColor(statusBarColor);

        this.showResultMessage = true;

        //Hide success RippleResult automatically after 3 sec; failed, 3 secs
        const closeResultInMilliseconds = this.result.message ? 3000 : 3000;

        setTimeout(() => {
          this.updateResult({ show: false });
        }, closeResultInMilliseconds);
      };

      animator.rippleTransition(
        rippleEleId,
        rippleEleId,
        300,
        0,
        this.getScaleTo(),
        null,
        this.selectedRadialColor,
        true,
        false,
        completeCallback
      );
    },
    getScaleTo() {
      const scaleConstant = this.isMobileDevice() ? 2 : 3; //Mobile +2; Desktop +3 or +6
      return Math.ceil(this.windowInfo().max / 56) + scaleConstant;
    },
    rippleShrink() {
      this.showResultMessage = false;
      let rippleEleId = "rippleResultEffect";

      let completeCallback = () => {
        this.internalShow = false;
      };

      animator.rippleTransition(
        rippleEleId,
        rippleEleId,
        200,
        this.getScaleTo(),
        0,
        null,
        this.selectedRadialColor,
        true,
        false,
        completeCallback
      );
    },
  },
  watch: {
    "result.show": {
      immediate: false,
      handler(newValue, oldValue) {
        if (newValue) {
          this.internalShow = newValue;
          this.setStatusBackgroundBarColor("#000000");
          this.rippleExpand();
        } else {
          this.rippleShrink();

          this.setThemeColorByMode();

          //Insurance
          setTimeout(() => {
            this.setThemeColorByMode();
          }, 100);
        }
      },
    },
  },
  created() {
    this.internalShow = this.result.show;
  },
};
</script>

